export default __webpack_public_path__ + "b0f48a070d58986862c49c1d4b8d0fd6.jpg";